<template>
  <!--	노션 링크 : https://www.notion.so/ReservInfoPage-0cd7c8d24f8347569f8c57ffffdbae15 -->
  <div>
    <div>
      <breadcrumb :breadcrumb_link="reservinfo_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">RESERVATION GUIDE</h1>
      <!--      <img src="@/assets/images/Podohotel/room_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container contentDesc">
      <div class="title1 mb-3">
        <h2>
          <strong>{{ $t('reservguide_title') }}</strong>
        </h2>
      </div>
    </div>
    <div class="container">
      <GallerySlideCarousels :slides="slides" :slide-count="4" :thumb-slide-width="60" />

      <div class="mt-5">
        <table class="reserv_table table table-borderless">
          <tbody style="border-top: 2px solid; border-bottom: 1px solid" align="center">
            <tr style="border-bottom: 1px solid #acacac; background-color: #f5f5f5">
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr1_td1') }}</td>
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr1_td2') }}</td>
              <td>{{ $t('reservguide_table_tr1_td3') }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #acacac">
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr2_td1') }}</td>
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr2_td2') }}</td>
              <td>{{ $t('reservguide_table_tr2_td3') }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #acacac">
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr3_td1') }}</td>
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr3_td2') }}</td>
              <td>{{ $t('reservguide_table_tr3_td3') }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #acacac">
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr4_td1') }}</td>
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr4_td2') }}</td>
              <td>{{ $t('reservguide_table_tr4_td3') }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #acacac">
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr5_td1') }}</td>
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr5_td2') }}</td>
              <td>{{ $t('reservguide_table_tr5_td3') }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #acacac">
              <td style="border-right: 1px solid #acacac" v-html="$t('reservguide_table_tr6_td1')"></td>
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr6_td2') }}</td>
              <td>{{ $t('reservguide_table_tr6_td3') }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #acacac">
              <td style="border-right: 1px solid #acacac" v-html="$t('reservguide_table_tr7_td1')"></td>
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr7_td2') }}</td>
              <td>{{ $t('reservguide_table_tr7_td3') }}</td>
            </tr>

            <tr style="border-bottom: 1px solid #acacac">
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr8_td1') }}</td>
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr8_td2') }}</td>
              <td>{{ $t('reservguide_table_tr8_td3') }}</td>
            </tr>
            <!--            <tr style="border-bottom: 1px solid #acacac">-->
            <!--              <td style="border-right: 1px solid #acacac">그린사이드BBQ&힐링</td>-->
            <!--              <td style="border-right: 1px solid #acacac">2인 / 4인</td>-->
            <!--              <td>&#8361;1,100,000 ~</td>-->
            <!--            </tr>-->
            <tr style="border-bottom: 1px solid #acacac">
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr9_td1') }}</td>
              <td style="border-right: 1px solid #acacac">{{ $t('reservguide_table_tr9_td2') }}</td>
              <td>{{ $t('reservguide_table_tr9_td3') }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-5">
        <div class="row d-flex justify-content-center no-gutters">
          <div class="col-lg-12 col-12">
            <b-table-simplem class="textStyle">
              <b-tr>
                <b-td class="tWidth">&#8251;</b-td>
                <b-td>{{ $t('reservguide_table_desc1') }}</b-td>
              </b-tr>
              <b-tr>
                <b-td class="tWidth">&#8251;</b-td>
                <b-td>{{ $t('reservguide_table_desc2') }}</b-td>
              </b-tr>
              <b-tr>
                <b-td class="tWidth">&#8251;</b-td>
                <b-td>{{ $t('reservguide_table_desc3') }}</b-td>
              </b-tr>
              <b-tr>
                <b-td class="tWidth">&#8251;</b-td>
                <b-td>{{ $t('reservguide_table_desc4') }}</b-td>
              </b-tr>
              <b-tr>
                <b-td class="tWidth">&#8251;</b-td>
                <b-td>{{ $t('reservguide_table_desc5') }}</b-td>
              </b-tr>
            </b-table-simplem>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12">
            <table class="webTable2 table table-borderless">
              <tbody>
                <tr style="border-top: 1px dashed #acacac; border-bottom: 1px dashed #acacac">
                  <td width="5%"><b-icon icon="phone" font-scale="3" style="padding: 5px 5px 5px 5px"></b-icon></td>
                  <td width="45%">TEL : 064-793-7070, 010-5328-7050<br />EMAIL : pinxleisure@sk.com</td>
                  <td width="5%">
                    <b-icon icon="calendar2-check" font-scale="3" style="padding: 5px 5px 5px 5px"></b-icon>
                  </td>
                  <td width="45%">{{ $t('reservguide_info_day') }}<br />{{ $t('reservguide_info_time') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-12">
            <table class="mobTable2 table table-borderless">
              <tbody>
                <tr style="border-top: 1px dashed #acacac; border-bottom: 1px dashed #acacac">
                  <td><b-icon icon="phone" font-scale="3" style="padding: 5px 5px 5px 5px"></b-icon></td>
                  <td style="width: 100%">TEL : 064-793-7070, 010-5328-7050<br />EMAIL : pinxleisure@sk.com</td>
                </tr>
                <tr>
                  <td><b-icon icon="calendar2-check" font-scale="3" style="padding: 5px 5px 5px 5px"></b-icon></td>
                  <td>{{ $t('reservguide_info_day') }}<br />{{ $t('reservguide_info_time') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row mt-5 mb-5">
          <div class="webTable col-lg-6 col-12">
            <h5>
              <b-icon scale="1%" icon="exclamation-circle-fill"></b-icon
              ><strong class="rev_subtitle">{{ $t('reservguide_noshow_title') }}</strong>
            </h5>

            <b-table-simplem class="textStyle2">
              <b-tr>
                <b-td class="tWidth">&#8251;</b-td>
                <b-td v-html="$t('reservguide_noshow_desc1')"></b-td>
              </b-tr>
              <b-tr>
                <b-td class="tWidth">&#8251;</b-td>
                <b-td>{{ $t('reservguide_noshow_desc2') }}</b-td>
              </b-tr>
            </b-table-simplem>
          </div>
          <div class="webTable col-lg-6 col-12">
            <h5>
              <b-icon scale="1%" icon="exclamation-circle-fill"></b-icon
              ><strong>{{ $t('reservguide_caution_title') }}</strong>
            </h5>
            <b-table-simplem class="textStyle2">
              <b-tr>
                <b-td class="tWidth">&#8251;</b-td>
                <b-td>{{ $t('reservguide_caution_desc1') }}</b-td>
              </b-tr>
              <b-tr>
                <b-td class="tWidth">&#8251;</b-td>
                <b-td>{{ $t('reservguide_caution_desc2') }} </b-td>
              </b-tr>
            </b-table-simplem>
          </div>
          <div class="mobTable col-lg-6 col-12">
            <h5>
              <b-icon scale="1%" icon="exclamation-circle-fill"></b-icon
              ><strong class="rev_subtitle"> {{ $t('reservguide_noshow_title') }}</strong>
            </h5>

            <table class="textStyle2 w-100">
              <tbody>
                <tr>
                  <td style="width: 4%">&#8251;</td>
                  <td style="width: 96%" v-html="$t('reservguide_noshow_desc1')"></td>
                </tr>
                <tr>
                  <td class="tWidth">&#8251;</td>
                  <td>{{ $t('reservguide_noshow_desc2') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mobTable col-lg-6 col-12">
            <h5>
              <b-icon scale="1%" icon="exclamation-circle-fill"></b-icon
              ><strong>{{ $t('reservguide_caution_title') }}</strong>
            </h5>
            <table class="textStyle2 w-100">
              <tbody>
                <tr>
                  <td style="width: 4%">&#8251;</td>
                  <td style="width: 96%">
                    {{ $t('reservguide_caution_desc1') }}
                  </td>
                </tr>
                <tr>
                  <td class="tWidth">&#8251;</td>
                  <td>
                    {{ $t('reservguide_caution_desc2') }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col buttonArea">
          <router-link v-show="isLang === 0" to="/p/Realtimebooking2" class="resserve-button">
            {{ $t('reserv_button') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'ReservinfoPage',
  data() {
    return {
      isLang: 0,
      reservinfo_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'RESERVATION',
        present: this.$t('breadcrumb'),
      },
      slides: [
        {image: require('@/assets/images/pleisure/program/pleisure_bodyimage01.jpg')},
        {image: require('@/assets/images/pleisure/program/pleisure_bodyimage02.jpg')},
        {image: require('@/assets/images/pleisure/program/pleisure_bodyimage03.jpg')},
        {image: require('@/assets/images/pleisure/program/pleisure_bodyimage04.jpg')},
        {image: require('@/assets/images/pleisure/program/pleisure_bodyimage05.jpg')},
      ],
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.reservinfo_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'RESERVATION',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  components: {Breadcrumb, GallerySlideCarousels},
};
</script>

<style scoped lang="scss">
p,
h1,
h2,
h3,
h4,
h5,
td,
b-td {
  word-break: keep-all;
}

.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}
li {
  padding-top: 7px;
  padding-bottom: 6px;
  padding-right: 20px;
  //border-bottom: 1px dotted #acacac;
  letter-spacing: -0.4px;
  list-style: none;
  font-size: 0.9rem;
}
.etc:before {
  content: '';
}
li:before {
  content: 'ㆍ';
  display: inline-block;
  vertical-align: middle;
}
table {
  td {
    vertical-align: middle;
  }
  margin: 0px;
}
.tWidth {
  width: 1.5rem;
}
.textStyle {
  font-size: 0.9rem;
  line-height: 1.5rem;
}
.textStyle2 {
  td {
    border-bottom: 1px solid #e0e0e0;
    font-size: 0.9rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
.textStyle3 {
  td {
    font-size: 0.9rem;
    border-bottom: 1px solid #e0e0e0;
    line-height: 1rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
::v-deep a {
  color: #000 !important;
}
::v-deep .nav-tabs .nav-link.active {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: #000;
  font-weight: 600;
}
.rev_etc {
  font-size: 0.75rem;
  color: #bc1b00;
  padding-top: 0.5rem;
  margin-left: 0.7rem;
  text-indent: -0.9rem;
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: center;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff !important;
  }
}
@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/common/reserveInfo_headerimage.jpg');
  }
  .webTable {
    display: block;
  }
  .webTable2 {
    display: table;
  }
  .mobTable {
    display: none;
  }
  .mobTable2 {
    display: none;
  }
}

@media (max-width: 992px) {
  .headerimage {
  }

  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }
  .webTable {
    display: none;
  }
  .webTable2 {
    display: none;
  }
  .mobTable {
    display: block;
    margin-top: 2rem;
  }
  .mobTable2 {
    display: block;
  }
  .mHead {
    height: 5rem;
  }
  .mBody {
    width: 5rem;
    text-align: center;
  }
  .rev_subtitle {
    font-size: 1.1rem;
  }
}

.offersStyle {
  background-color: #eeeeee;
  padding-bottom: 3rem;
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "예약 안내",
    "reservguide_title": "예약 안내",
    "reservguide_table_tr1_td1": "프로그램",
    "reservguide_table_tr1_td2": "기준인원 / 최대인원",
    "reservguide_table_tr1_td3": "요금",
    "reservguide_table_tr2_td1": "프라이빗 럭셔리 요트",
    "reservguide_table_tr2_td2": "2인 / 10인",
    "reservguide_table_tr2_td3": "₩1,700,000 ~",
    "reservguide_table_tr3_td1": "챌린저골프",
    "reservguide_table_tr3_td2": "2인 / 3인",
    "reservguide_table_tr3_td3": "₩1,700,000 ~",
    "reservguide_table_tr4_td1": "노블승마",
    "reservguide_table_tr4_td2": "2인 / 4인",
    "reservguide_table_tr4_td3": "₩800,000 ~",
    "reservguide_table_tr5_td1": "제주어부",
    "reservguide_table_tr5_td2": "2인 / 10인",
    "reservguide_table_tr5_td3": "₩1,400,000 ~",
    "reservguide_table_tr6_td1": "해피투게더",
    "reservguide_table_tr6_td2": "2인 / 6인",
    "reservguide_table_tr6_td3": "₩650,000 ~",
    "reservguide_table_tr7_td1": "제주 숲토리텔링 투어",
    "reservguide_table_tr7_td2": "2인 / 6인",
    "reservguide_table_tr7_td3": "₩400,000 ~",
    "reservguide_table_tr8_td1": "아트앤힐링",
    "reservguide_table_tr8_td2": "2인 / 6인",
    "reservguide_table_tr8_td3": "₩550,000 ~",
    "reservguide_table_tr9_td1": "프라이빗 힐링 요가",
    "reservguide_table_tr9_td2": "2인 / 8인",
    "reservguide_table_tr9_td3": "₩550,000 ~",
    "reservguide_table_desc1": "모든 예약은 7일 전 예약을 원칙으로 합니다.",
    "reservguide_table_desc2": "5세 이상부터 1인 요금이 적용됩니다.",
    "reservguide_table_desc3": "경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "reservguide_table_desc4": "모든 프로그램은 여행자보험 포함 상품입니다.",
    "reservguide_table_desc5": "정원 외 인원은 별도 문의 바랍니다.",
    "reservguide_info_day": "상담시간 : 월 ~ 금 (공휴일 제외)",
    "reservguide_info_time": "09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)",
    "reservguide_noshow_title": " 예약 취소/변경 및 NO-SHOW 안내",
    "reservguide_noshow_desc1": "단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.<br/>(프로그램 별 상이)",
    "reservguide_noshow_desc2": "천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "reservguide_caution_title": " 예약 시 주의사항",
    "reservguide_caution_desc1": "여행시간 미 준수, 여행 장소 이탈, 제공된 서비스 외에 부당한 추가 서비스의 불합리한 요구",
    "reservguide_caution_desc2": "진행자의 이용안내 및 준수사항을 준수하지 않고, 이를 위반하여 안전사고 등의 불미한 사고가 발생했을 경우 여행자 본인이 책임을 진다.",
    "reserv_button": "예약신청"
  },
  "en": {
    "breadcrumb": "Reservation Guide",
    "reservguide_title": "Reservation Guide",
    "reservguide_table_tr1_td1": "Program",
    "reservguide_table_tr1_td2": "Standard Occupancy & Maximum Occupancy",
    "reservguide_table_tr1_td3": "Normal Price",
    "reservguide_table_tr2_td1": "Private Luxury Yacht",
    "reservguide_table_tr2_td2": "2 persons / 10 persons",
    "reservguide_table_tr2_td3": "KRW 1,700,000 ~",
    "reservguide_table_tr3_td1": "Challenger Golf",
    "reservguide_table_tr3_td2": "2 persons / 3 persons",
    "reservguide_table_tr3_td3": "KRW 1,700,000 ~",
    "reservguide_table_tr4_td1": "Noble Horseback Riding",
    "reservguide_table_tr4_td2": "2 persons / 4 persons",
    "reservguide_table_tr4_td3": "KRW 800,000 ~",
    "reservguide_table_tr5_td1": "Jeju Fisherman",
    "reservguide_table_tr5_td2": "2 persons / 10 persons",
    "reservguide_table_tr5_td3": "KRW 1,400,000 ~",
    "reservguide_table_tr6_td1": "Happy Together<br/>(Forest storytelling)",
    "reservguide_table_tr6_td2": "2 persons / 6 persons",
    "reservguide_table_tr6_td3": "KRW 650,000 ~",
    "reservguide_table_tr7_td1": "Jeju Sooptorytelling Tour<br/>(Forest trekking)",
    "reservguide_table_tr7_td2": "2 persons / 6 persons",
    "reservguide_table_tr7_td3": "KRW 400,000 ~",
    "reservguide_table_tr8_td1": "Art & Healing",
    "reservguide_table_tr8_td2": "2 persons / 6 persons",
    "reservguide_table_tr8_td3": "KRW 550,000 ~",
    "reservguide_table_tr9_td1": "Private Healing Yoga",
    "reservguide_table_tr9_td2": "2 persons / 8 persons",
    "reservguide_table_tr9_td3": "KRw 550,000 ~",
    "reservguide_table_desc1": "All reservations requires an advance booking 7 days before.",
    "reservguide_table_desc2": "One-person price applies for children aged 5 or older.",
    "reservguide_table_desc3": "In some cases, minors may need a guardian.",
    "reservguide_table_desc4": "Traveler's insurance is included in all products.",
    "reservguide_table_desc5": "Contact us for the group of people other than the number in the above.",
    "reservguide_info_day": "MON ~ FRI (Excluding public holidays)",
    "reservguide_info_time": "09:00 ~ 17:30 (Lunch 12:00 ~ 13:00)",
    "reservguide_noshow_title": " Penalty information about booking cancellation/change & No-show",
    "reservguide_noshow_desc1": " The company’s cancellation policy shall apply in the case of cancellation or refund due to a simple change in mind. (Different by each program)",
    "reservguide_noshow_desc2": " In case of cancellation due to natural disasters or unavoidable circumstances due to the company's operational reason, the cancellation policy shall not apply.",
    "reservguide_caution_title": " Cautions",
    "reservguide_caution_desc1": " Non-compliance with travel time, stay out of the destination, and unreasonable demand for extra service in addition to the service provided. ",
    "reservguide_caution_desc2": " The traveler himself/herself shall be responsible for any incident including safety accident resulted from the traveler’s failure to comply with the instructions and compliance of the moderator.",
    "reserv_button": "Book Now"
  },
  "ja": {
    "breadcrumb": "예약 안내",
    "reservguide_title": "예약 안내",
    "reservguide_table_tr1_td1": "프로그램",
    "reservguide_table_tr1_td2": "기준인원 / 최대인원",
    "reservguide_table_tr1_td3": "요금",
    "reservguide_table_tr2_td1": "프라이빗 럭셔리 요트",
    "reservguide_table_tr2_td2": "2인 / 10인",
    "reservguide_table_tr2_td3": "₩1,700,000 ~",
    "reservguide_table_tr3_td1": "챌린저골프",
    "reservguide_table_tr3_td2": "2인 / 3인",
    "reservguide_table_tr3_td3": "₩1,700,000 ~",
    "reservguide_table_tr4_td1": "노블승마",
    "reservguide_table_tr4_td2": "2인 / 4인",
    "reservguide_table_tr4_td3": "₩800,000 ~",
    "reservguide_table_tr5_td1": "제주어부",
    "reservguide_table_tr5_td2": "2인 / 10인",
    "reservguide_table_tr5_td3": "₩1,400,000 ~",
    "reservguide_table_tr6_td1": "해피투게더",
    "reservguide_table_tr6_td2": "2인 / 6인",
    "reservguide_table_tr6_td3": "₩650,000 ~",
    "reservguide_table_tr7_td1": "제주 숲토리텔링 투어",
    "reservguide_table_tr7_td2": "2인 / 6인",
    "reservguide_table_tr7_td3": "₩400,000 ~",
    "reservguide_table_tr8_td1": "아트앤힐링",
    "reservguide_table_tr8_td2": "2인 / 6인",
    "reservguide_table_tr8_td3": "₩550,000 ~",
    "reservguide_table_tr9_td1": "프라이빗 힐링 요가",
    "reservguide_table_tr9_td2": "2인 / 8인",
    "reservguide_table_tr9_td3": "₩550,000 ~",
    "reservguide_table_desc1": "모든 예약은 7일 전 예약을 원칙으로 합니다.",
    "reservguide_table_desc2": "5세 이상부터 1인 요금이 적용됩니다.",
    "reservguide_table_desc3": "경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "reservguide_table_desc4": "모든 프로그램은 여행자보험 포함 상품입니다.",
    "reservguide_table_desc5": "정원 외 인원은 별도 문의 바랍니다.",
    "resservguid_info_day": "상담시간 : 월 ~ 금 (공휴일 제외)",
    "resservguid_info_time": "09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)",
    "reservguide_noshow_title": "기타사항",
    "reservguide_noshow_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "reservguide_noshow_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "reservguide_caution_title": "기타사항",
    "reservguide_caution_desc1": "기타사항",
    "reservguide_caution_desc2": "기타사항"
  }
}
</i18n>
